var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form-layout',{attrs:{"title":`${_vm.action} ${_vm.$tc('product.part', 1)}`},on:{"submit":_vm.onSubmit}},[_c('v-form',{ref:"form"},[_c('ItemSalesQuotationEditForm',{attrs:{"item":_vm.itemSalesQuotation,"item-id":_vm.itemSalesQuotationId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }